import { Box, Typography } from 'seagull';
import { BulkBillingModalTestIds } from "../BulkBillingModal";
import { CheckSmall, CloseLiner24 } from 'seagull/icons';
import { selectors } from "../../../../store/state-selectors";
import { useStoreStatic } from "../../../../contexts";
import styles from "./BulkBillingResultsDetails.module.scss";
import ExternalLinkButton from "../../../../components/ExternalLinkButton";
import classNames from 'classnames';
import pluralize from "../../../../utils/pluralize";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BulkBillingResultsDetails = _ref => {
  let {
    success,
    failure,
    bulkUploadId
  } = _ref;
  const {
    getState
  } = useStoreStatic();
  const mgmtHost = selectors.mgmtHost(getState());
  return /*#__PURE__*/_jsxs(Box, {
    className: styles.bulkBillingResultsDetails,
    children: [/*#__PURE__*/_jsxs(Box, {
      className: styles.bulkBillingResultsDetailsLines,
      children: [/*#__PURE__*/_jsxs(Typography, {
        className: classNames(styles.bulkBillingResultsDetailsLineItem, styles.bulkBillingResultsDetailsSuccess),
        variant: "paragraph1",
        "data-testid": BulkBillingModalTestIds.BulkBillingResultsDetails.Success(),
        skin: "success",
        children: [/*#__PURE__*/_jsx(CheckSmall, {}), " ", success, " ", pluralize('invoice', success), " billed successfully"]
      }), /*#__PURE__*/_jsxs(Typography, {
        className: classNames(styles.bulkBillingResultsDetailsLineItem, styles.bulkBillingResultsDetailsFailure),
        variant: "paragraph1",
        "data-testid": BulkBillingModalTestIds.BulkBillingResultsDetails.Failure(),
        skin: "error",
        children: [/*#__PURE__*/_jsx(CloseLiner24, {}), failure, " ", pluralize('invoice', failure), " could not be billed due to an unknown error."]
      })]
    }), /*#__PURE__*/_jsxs(Typography, {
      skin: "secondary",
      children: ["You can", ' ', /*#__PURE__*/_jsx(ExternalLinkButton, {
        "data-testid": BulkBillingModalTestIds.BulkBillingResultsDetails.DownloadResults(),
        href: "".concat(mgmtHost, "/billing/bulk/billing/").concat(bulkUploadId, "/failed-csv"),
        target: "_blank",
        children: "download a csv"
      }), ' ', "of the line ", pluralize('item', failure), " that could not be billed. For more details, please contact support."]
    })]
  });
};